import React from 'react';
import {
 HashRouter as Router, Route, Switch, Redirect 
} from 'react-router-dom';
import Loadable from 'react-loadable';
import Pym from 'pym.js';
import Loading from '../pages/Loading';
// import DataOverview from '../pages/DataOverview';
// import OperationalFocus from '../pages/OperationalFocus';
// import Operations from '../pages/Operations';
// import Members from '../pages/Members';
// import Deployments from '../pages/Deployments';
// import WorkOrders from '../pages/WorkOrders';
// import NetPromoterScore from '../pages/NetPromoterScore';
// import Value from '../pages/Value';
// import Training from '../pages/Training';
// import Funding from '../pages/Funding';
// import HurricaneFlorence from '../pages/HurricaneFlorence';
// import HurricaneMaria from '../pages/HurricaneMaria';
// import HurricaneHarvey from '../pages/HurricaneHarvey';
// import HurricaneMichael from '../pages/HurricaneMichael';

const DataOverview = Loadable({
  loader: () => import('../pages/DataOverview'),
  loading: Loading,
});
// const OperationalFocus = Loadable({
//   loader: () => import('../pages/OperationalFocus'),
//   loading: Loading,
// });
const Operations = Loadable({
  loader: () => import('../pages/Operations'),
  loading: Loading,
});
const Members = Loadable({
  loader: () => import('../pages/Members'),
  loading: Loading,
});
const Deployments = Loadable({
  loader: () => import('../pages/Deployments'),
  loading: Loading,
});
const WorkOrders = Loadable({
  loader: () => import('../pages/WorkOrders'),
  loading: Loading,
});
const NetPromoterScore = Loadable({
  loader: () => import('../pages/NetPromoterScore'),
  loading: Loading,
});
const Value = Loadable({
  loader: () => import('../pages/Value'),
  loading: Loading,
});
const Training = Loadable({
  loader: () => import('../pages/Training'),
  loading: Loading,
});
const Funding = Loadable({
  loader: () => import('../pages/Funding'),
  loading: Loading,
});
const HurricaneFlorence = Loadable({
  loader: () => import('../pages/HurricaneFlorence'),
  loading: Loading,
});
const HurricaneMaria = Loadable({
  loader: () => import('../pages/HurricaneMaria'),
  loading: Loading,
});
const HurricaneHarvey = Loadable({
  loader: () => import('../pages/HurricaneHarvey'),
  loading: Loading,
});
const HurricaneMichael = Loadable({
  loader: () => import('../pages/HurricaneMichael'),
  loading: Loading,
});

class App extends React.Component {
  componentDidMount() {
    const pymChild = new Pym.Child();
    pymChild.sendHeight();
  }

  render() {
    return (
      <Router>
        <Switch>
          <Route exact path="/" component={DataOverview} />
          <Route exact path="/operations" component={Operations} />
          <Route exact path="/members" component={Members} />
          <Route exact path="/deployments" component={Deployments} />
          <Route exact path="/work-orders" component={WorkOrders} />
          <Route exact path="/net-promoter-score" component={NetPromoterScore} />
          <Route exact path="/value" component={Value} />
          <Route exact path="/training" component={Training} />
          <Route exact path="/funding" component={Funding} />
          <Route exact path="/hurricane-florence" component={HurricaneFlorence} />
          <Route exact path="/hurricane-maria" component={HurricaneMaria} />
          <Route exact path="/hurricane-harvey" component={HurricaneHarvey} />
          <Route exact path="/hurricane-michael" component={HurricaneMichael} />
          <Redirect to="/" />
          <Route component={DataOverview} />
        </Switch>
      </Router>
    );
  }
}

export default App;
